import Connections from './Connections/Connections';
import Feeds from './Feeds/Feeds';
import Webshops from './Webshops/Webshops';

class Clients {
    constructor(settings) {
        this.settings = settings;

        this.webshops = new Webshops(this.settings);
        this.feeds = new Feeds(this.settings);
        this.connections = new Connections(this.settings);
    }
}

export default Clients;
